import { PrintAgentStatus } from '@/types'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import {
Tooltip,
TooltipContent,
TooltipProvider,
TooltipTrigger,
} from '@/components/ui/tooltip'

interface AgentStatusBadgeProps {
  status: PrintAgentStatus
  className?: string
  dotOnly?: boolean
}

export function AgentStatusBadge({
  status,
  className,
  dotOnly = false,
}: AgentStatusBadgeProps) {
  const isOnline = status === PrintAgentStatus.ONLINE
  const label = isOnline ? 'Online' : 'Offline'

  if (dotOnly) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span
              className={cn(
                'w-2 h-2 rounded-full shrink-0 cursor-help',
                isOnline ? 'bg-green-500' : 'bg-red-500',
                className
              )}
            />
          </TooltipTrigger>
          <TooltipContent side="top" align="center">
            {label}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  }

  return (
    <Badge
      variant="outline"
      className={cn(
        'font-medium text-xs',
        isOnline
          ? 'bg-green-500/10 text-green-700 border-green-500/20'
          : 'bg-red-500/10 text-red-700 border-red-500/20',
        className
      )}
    >
      <span
        className={cn(
          'w-1.5 h-1.5 rounded-full mr-1.5',
          isOnline ? 'bg-green-600' : 'bg-red-600'
        )}
      />
      {label}
    </Badge>
  )
}
